var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// MUI Imports
import { Box } from "@mui/system";
// Style imports
// import "./ContentCreator.css";
import VTHotspotContent from "./VTHotspotContent";
export default function VTHotspotContentViewer2(_a) {
    var data = _a.data, onClick = _a.onClick, onHover = _a.onHover, sx = _a.sx;
    return (_jsx(_Fragment, { children: _jsx(Box, __assign({ onClick: onClick, onMouseOver: function () { return onHover && onHover(true); }, onMouseLeave: function () { return onHover && onHover(false); }, component: "div", className: "container", sx: __assign({ 
                // width: `${width}px`,
                // height: `${height}px`,
                position: "relative" }, sx) }, { children: data.map(function (d) { return (_jsx(VTHotspotContent, { content: d, currentTarget: d.id, viewer: true })); }) })) }));
}
